import { ComponentDescriptions } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import keyBy from 'lodash/keyBy';
import { weakMapMemoize } from '@reduxjs/toolkit';

const mapComponentDescriptionsByName = weakMapMemoize((descriptions: ComponentDescriptions | undefined) =>
  keyBy(descriptions, (description) => description.name),
);

export default mapComponentDescriptionsByName;
